// removed by extract-text-webpack-plugin
module.exports = {"SendingAccount":"SendingAccount","SendingAccountTitle":"SendingAccountTitle","SendingAccountContent":"SendingAccountContent","SendingAccountLeft":"SendingAccountLeft","BrokerPhoneCode":"BrokerPhoneCode","PhoneCode":"PhoneCode","SendingAccountRight":"SendingAccountRight","SendingAccountSVG":"SendingAccountSVG","ErrorPhoneCode":"ErrorPhoneCode","SendingAccountDropdown":"SendingAccountDropdown","ReactVirtualized__Grid":"ReactVirtualized__Grid","ReactVirtualized__List":"ReactVirtualized__List","VirtualSelectGrid":"VirtualSelectGrid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer/Common/SendingAccount/styles.scss
// module id = 2218
// module chunks = 10